<template>
  <div class="">
    <pdf-edit> </pdf-edit>
  </div>
</template>

<script>
import PdfEdit from "@/components/profile/lisacomunica/pdf/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    PdfEdit,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Pdf",
        path: "lisacomunica_template",
        tab: "Pdf",
        level: 3,
      });
      bcs.push({
        text: "Modifica template PDF",
        path: "pdf.edit",
        level: 4,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Pdf",
        path: "lisacomunica_template",
        tab: "Pdf",
        level: 3,
      });
      this.notifyQueue({
        text: "Modifica template pdf",
        path: "pdf.edit",
        level: 4,
      });
    }
  },
};
</script>
